import { render, staticRenderFns } from "./ImportTaxInvoice.vue?vue&type=template&id=88b87334&scoped=true"
import script from "./ImportTaxInvoice.vue?vue&type=script&lang=js"
export * from "./ImportTaxInvoice.vue?vue&type=script&lang=js"
import style0 from "./ImportTaxInvoice.vue?vue&type=style&index=0&id=88b87334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b87334",
  null
  
)

export default component.exports